import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-liste-valeurs-parametrables',
    templateUrl: './liste-valeurs-parametrables.component.html',
    styleUrls: ['./liste-valeurs-parametrables.component.scss'],
    standalone: false
})
export class ListeValeursParametrablesComponent {
    constructor(private readonly route: ActivatedRoute, private readonly router: Router) {}

    goToListes(liste: string) {
        this.router.navigate(['.', liste], { relativeTo: this.route.parent });
    }
}
